import Grid from '@mui/material/Grid';
import { t } from 'i18next';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

import { TextFormField } from '~components/FormFields/TextFormField';
import useDispatchNumberLabel from '~hooks/useDispatchNumberLabel';

interface OrderCustomerDetailsProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  disabled?: boolean;
  errors: FieldErrors<TFieldValues>;
  tomlinsonOrderModalFeatureFlagEnabled?: boolean;
}

export const OrderCustomerDetails = <TFieldValues extends FieldValues = FieldValues>({
  control,
  errors,
  disabled = false,
  tomlinsonOrderModalFeatureFlagEnabled,
}: OrderCustomerDetailsProps<TFieldValues>) => {
  const { singular } = useDispatchNumberLabel();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <TextFormField
          control={control}
          errors={errors}
          name={'name'}
          label={`${t('order.form.order_name')}`}
          isRequired={false}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <TextFormField
          control={control}
          errors={errors}
          name={'dispatchNumber'}
          label={singular('order.form.dispatch_number_full')}
          isRequired={false}
          disabled={disabled}
        />
      </Grid>

      {tomlinsonOrderModalFeatureFlagEnabled ? null : (
        <>
          <Grid size={{ xs: 4 }}>
            <TextFormField
              control={control}
              errors={errors}
              name={'poJobNumber'}
              label={`${t('order.form.order_po')}`}
              isRequired={false}
              disabled={disabled}
            />
          </Grid>
          <Grid size={{ xs: 4 }}>
            <TextFormField
              control={control}
              errors={errors}
              name={'zone'}
              label={`${t('order.form.order_zone')}`}
              isRequired={false}
              disabled={disabled}
            />
          </Grid>
          <Grid size={{ xs: 4 }}>
            <TextFormField
              control={control}
              errors={errors}
              name={'externalId'}
              label={`${t('form_fields.external_id')}`}
              isRequired={false}
              disabled={disabled}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
